import * as React from 'react';

import { FacilityGroupRecord } from '@rematter/modules/facilities/types/facilityGroup';
import { Button, DataGridColumn } from '@rematter/ui-web';

import { useTranslations } from '@/facilities/i18n/useTranslations';

type UseFacilityGroupListColumnsArgs = {
  onEdit?: (row: FacilityGroupRecord) => void;
};

export const useFacilityGroupListColumns = ({
  onEdit,
}: UseFacilityGroupListColumnsArgs = {}): DataGridColumn<FacilityGroupRecord>[] => {
  const t = useTranslations();

  return React.useMemo(() => {
    const columns: DataGridColumn<FacilityGroupRecord>[] = [
      {
        key: 'name',
        header: t.facilityGroups.list.columns.name,
        width: 250,
        cell: ({ row }) => row.name,
      },
      {
        key: 'facilities',
        header: t.facilityGroups.list.columns.facilities,
        width: 400,
        cell: ({ row }) => (
          <div className="flex flex-wrap gap-1">
            {row.facilities.map((facility) => (
              <span
                key={facility.id}
                className="rounded-md bg-neutral/10 px-2 py-1 text-sm"
              >
                {facility.facilityName}
              </span>
            ))}
          </div>
        ),
      },
      {
        key: 'actions',
        header: '',
        width: 200,
        cell: ({ row }) => (
          <div className="flex gap-2">
            <Button
              color="primary"
              className="grow border border-primary/40 shadow-sm shadow-neutral/10"
              onPress={() => onEdit?.(row)}
              size="small"
            >
              {t.facilityGroups.list.actions.viewDetails}
            </Button>
          </div>
        ),
      },
    ];
    return columns;
  }, [t, onEdit]);
};
